import React, { useState, useEffect } from 'react';
import { compose } from 'redux';
import { connect } from 'react-redux';
import { withStyles } from '@material-ui/core/styles';
import ListItem from '@material-ui/core/ListItem';
import ListItemText from '@material-ui/core/ListItemText';
import Menu from '@material-ui/core/Menu';
import ArrowDropDownIcon from '@material-ui/icons/ArrowDropDown';
import classNames from 'classnames';
import {
  takeValuation,
  fetchTxnOppValuations
} from 'store/actions';

const AuctionUWUnderwriterSelector = ({ classes, selectedUnderwriter, auctionTxnOpp,
  takeValuation, fetchTxnOppValuations, selectedAuctionTxnOppValuations
}) => {
  const [underwriterName, setUnderwriterName] = useState('');
  const [dropdownOpen, setDropdownOpen] = useState(false);
  const [anchorEl, setAnchorEl] = useState(null);
  const [isLoading, setIsLoading] = useState(false);

  useEffect(() => {
    setUnderwriterName(selectedUnderwriter);
  }, [selectedUnderwriter]);

  useEffect(() => {
    if (dropdownOpen && selectedAuctionTxnOppValuations?.txnOppId !== auctionTxnOpp.id) {
      setIsLoading(true);
      setTimeout(() => fetchTxnOppValuations(auctionTxnOpp.id, handleSuccess), 200); // Timeout to ensure loading is displayed
    }
  }, [dropdownOpen]);

  const handleSuccess = () => {
    setIsLoading(false);
  }

  const handleDropdownChange = (valuation) => {
    setUnderwriterName(valuation.userName);
    setAnchorEl(null);
    setDropdownOpen(false);
    takeValuation(valuation.valuationId);
  }

  return (
    auctionTxnOpp.completedValuationsCount > 1
      ? <>
          <div
            onClick={(e) => {
              setAnchorEl(e.currentTarget);
              setDropdownOpen(true);
            }} className={classNames(classes.underwriterCell, 'gridUnderwriter')}>
            {underwriterName}
            <ArrowDropDownIcon className={classes.arrowDropdownIcon} />
          </div>
          <Menu
            open={dropdownOpen}
            onClose={() => {
              setAnchorEl(null);
              setDropdownOpen(false);
            }}
            anchorEl={anchorEl}>
            {isLoading
              ? <ListItem key={1} value={'Loading'} className={classes.listItem}>
                  <div style={{width: 80, height: 60}}>Loading..</div>
                </ListItem>
              : selectedAuctionTxnOppValuations?.valuations && selectedAuctionTxnOppValuations.valuations.map(valuation => {
                  return (
                    <ListItem key={valuation.valuationId} value={valuation.userName} onClick={() => handleDropdownChange(valuation)} className={classes.listItem}>
                      <ListItemText primary={valuation.userName} value={valuation.userName} className={classes.listItemText} classes={{ primary: classes.listItemText }} />
                    </ListItem>
                  )
                })
            }
          </Menu>
        </>
      : auctionTxnOpp.completedValuationsCount === 1 // If only one underwriter and have completed all tasks, don't have dropdown
        ? <div>{auctionTxnOpp.selectedValuationUserName}</div>
        : null
  )
};

const styles = theme => ({
  underwriterCell: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'flex-end',
    cursor: 'pointer',
  },
  arrowDropdownIcon: {
    fontSize: '1rem',
  },
  listItem: {
    cursor: 'pointer',
  },
  listItemText: {
    fontSize: '0.75rem',
    lineHeight: '5px',
  }
});

const mapStateToProps = (state) => {
  return {
    selectedAuctionTxnOppValuations: state.auctionUWState.selectedAuctionTxnOppValuations
  }
};

const mapDispatchToProps = dispatch => ({
  takeValuation: (valuationId) => dispatch(takeValuation(valuationId)),
  fetchTxnOppValuations: (txnOppId, onSuccess) => dispatch(fetchTxnOppValuations(txnOppId, onSuccess))
});

export default compose(withStyles(styles), connect(mapStateToProps, mapDispatchToProps))(AuctionUWUnderwriterSelector);